<app-spinner id="spinner" [loading]="spinnerService.loading$ | async" />
<app-header-bar
  [title]="_title"
  [showClientDetails]="_showClientDetails"
  [showButton]="false"
  [age]="_age"
  [dob]="_dateOfBirth"
  (routerLinkClick)="previousRoute()"
  *ngIf="_dateOfBirth != undefined || _dateOfBirth != null"
/>
<!-- Client Information -->
<div class="dashboard-side-card-container">
  <app-client-information
    id="client-information"
    subtitle=""
    [title]="_clientInformationTitle"
    [urlDisplayText]="_clientInformationDisplayText"
    [url]="_clientInformationUrl"
    [attributes]="_clientInformationAttributes"
    [isVertialOrientation]="true"
  />
</div>
<!-- Sub-Menu -->
<app-sub-menu
  [clientId]="_clientId"
  [totalReviews]="_totalReviews"
  [flipHasAccess]="_hasAccess.flipHasAccess"
  [reddiHasAccess]="_hasAccess.reddiHasAccess"
  [slatHasAccess]="_hasAccess.slatHasAccess"
  [showBackButton]="true"
  (navigateBackClick)="previousRoute()"
/>
<div class="reddi-instance-container">
  <div class="reddi-instance-left-container">
    <div>
      <app-primary-card size="full" class="reddi-instance-primary-card">
        <div class="header">
          <div id="header-title" class="mat-headline-2">
            {{ 'REDDI Details' | translate }}
          </div>
          <div class="reddi-instance-locked-container">
            <app-action-toolbar
              [isEdit]="false"
              (editClick)="navigateTo('editReddi')"
              [isFullView]="false"
              (fullViewClick)="navigateTo('fullViewReddi')"
              [isHistory]="true"
              (historyClick)="navigateTo('historyReddi')"
              [isReport]="true"
              (reportClick)="navigateTo('reportReddi')"
              [isNew]="true"
              (newClick)="navigateTo('newReddi')"
            />
            <span class="material-symbols-outlined icon">lock</span>
            <span class="text">{{
              'This assessment is locked' | translate
            }}</span>
          </div>
        </div>

        <app-table
          id="reddi-round-table"
          [dataSource]="_tableData"
          [columnsToDisplay]="_tableColumnsToDisplay"
          [columnDefinitions]="_tableColumnDefinitions"
          [pageSize]="12"
          kind="standard"
        />
      </app-primary-card>
    </div>
    <app-reddi-graph-legend
      [showTitle]="true"
      [showReportLegend]="false"
    ></app-reddi-graph-legend>
  </div>
  <div class="reddi-instance-side-card">
    <app-side-card size="full" class="reddi-side-card">
      <app-reddi-logo />
      <div class="section">
        <div class="title">{{ 'Data entered by' | translate }}</div>
        <div class="text-highlight">{{ _dataEnteredBy }}</div>
      </div>
      <div class="section">
        <div class="title">{{ 'Sound Presented By' | translate }}</div>
        <div class="text-highlight">{{ _soundEnteredBy }}</div>
      </div>
      <div class="section">
        <div class="title">{{ 'Presentation Date' | translate }}</div>
        <div class="text-highlight">{{ _presentationDate }}</div>
      </div>
      <div class="section">
        <div class="title">{{ 'Considerations' | translate }}</div>
        <div *ngFor="let consideration of _considerations">
          <input type="checkbox" checked /><span class="text">{{
            consideration | translate
          }}</span>
        </div>
        <div *ngIf="_considerations.length === 0" class="text">
          {{ 'None Selected' | translate }}
        </div>
      </div>
      <div class="section">
        <div class="title">{{ 'Session Notes' | translate }}</div>
        <div class="text">{{ _notes }}</div>
      </div>
    </app-side-card>
  </div>
</div>
